// replace the user pool region, id, and app client id details
export default {
  REGION: "eu-central-1",
  USER_POOL_ID: "eu-central-1_a28Wn3mSt",
  USER_POOL_APP_CLIENT_ID: "2kgmv9uadnfs6qde69pd7fbe1l",
};
